{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Prikaži sve opcije",
  "Spoiler_Reveal_Tooltip": "Kliknite za prikaz",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweetaj ovo",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Stavka je sažeta",
  "Spoiler_Reveal_Video_CTA": "Otkrij videozapis",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Proširi sliku",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Prikaži sve rezultate",
  "Spoiler_Reveal_Image_Placeholder": "Ova slika sadrži spojler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Klizač reprodukcije",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Možete glasati za više od jednog odgovora.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Prikaži više kontrola zvuka",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Zatvori",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Učitavanje {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Pročitajte više",
  "Spoiler_Insert_Tooltip": "Spojler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Glasnoća",
  "Spoiler_Reveal_Gallery_Placeholder": "Ova galerija sadrži spojler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Rezerviraj odmah",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Uključi",
  "Spoiler_Reveal_Gallery_CTA": "Otkrij galeriju",
  "Poll_Viewer_ShowLess_CTA": "Prikaži manje",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Utišaj",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonimnih",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Prati",
  "VerticalEmbed_Products_Button": "Kupi odmah",
  "Poll_Viewer_Toast_Error_ServerDown": "Nije moguće spojiti se na poslužitelj. Pokušajte ponovno kasnije.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} osoba je glasala za ovaj odgovor",
  "Poll_Viewer_VoteCount": "{{number}} glasa/ova",
  "VerticalEmbed_Events_Button": "Prijavi se odmah",
  "Spoiler_Reveal_Image_CTA": "Otkrij sliku",
  "Poll_Viewer_Toast_Error_Connection": "Nema interneta. Provjerite vezu.",
  "Poll_Viewer_Visibility_Owner_Footer": "Samo vi možete vidjeti rezultate.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} osobe/a je glasalo za ovaj odgovor",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Stavka je proširena",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Ovaj videozapis sadrži spojler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Pogledaj cijelu objavu",
  "UploadFile_Viewer_Download": "Preuzmi {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
